import { NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class ScheduleInterceptionCommand  {
    public staticServiceProviderId: number = 0;

    public serviceProviderName: string | null = null;

    public serviceProviderCode: string | null = null;

    public interceptionStoredProcedureName: string = "";
}